<template>
    <b-overlay
        :show="mostrarLoader"
        opacity="0.50"
        rounded="sm"
        spinner-variant="primary"
        spinner-type="grow"
    >
        <div>
            <!-- Top section -->
            <div style="text-align: center; position: static; z-index: 2; background-color: #192A4A; width: 100%; top: 0; display:flex;box-shadow: 0px -57px 89px -4px rgba(29,54,98,1);">
                <div id="logoContainer">
                    <a href="https://www.legalbytez.com/" target="_blank">
                        <img class="logo" src="@/assets/img/logo/logo-2.png" alt="Logo">
                    </a>
                </div>
              </div>
        </div>

        <div class="pricing-free-trial mt-4 mb-0">
            <b-row>
              <b-col
                lg="10"
                offset-lg="3"
                class="mx-auto"
              >
                <div class="pricing-trial-content d-flex justify-content-between">
                  <div class="text-center text-md-left mt-3">
                    <h3 class="text-primary" style="font-size: 2.5rem;">
                        ¡Listo para finalizar tu compra!
                    </h3>
                    <h5>Ingresa tu información, verifica tu orden de compra y procede al pago de forma segura.</h5>
                    <a href="https://www.legalbytez.com/">
                        <b-button
                            variant="primary"
                            class="mt-2 mt-lg-3"
                        >
                            Volver a Inicio
                        </b-button>
                    </a>
                  </div>
      
                  <!-- images -->
                  <b-img
                    fluid
                    :src="require('@/assets/images/illustration/pricing-Illustration.svg')"
                    class="pricing-trial-img"
                    alt="svg img"
                  />
                  <!--/ images -->
                </div>
              </b-col>
            </b-row>
          </div>

        <!-- Checkout section -->
        <div id="checkout_container">
            <div class="checkout-area" style="padding-left: 10%; padding-right: 10%;">
                <validation-observer ref="checkoutValidation">
                    <b-form @submit.prevent>
                        <b-row>
                            <b-col lg="6">
                                <div class="checkout-form" style="padding-bottom: 0px;">
                                    <h3 class="titulo-checkout">Datos de Facturación</h3>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group class="mt-2 mb-2">
                                                <label>Nombre/Razón social <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Nombre"
                                                    rules="required"
                                                >
                                                    <b-form-input
                                                        id="nombre"
                                                        v-model="datosFacturacion.razon_social"
                                                        placeholder="Ingrese nombre o razón social..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="nombre"
                                                        maxlength="100"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="mb-2">
                                                <label>Cédula/RUC <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Cédula/RUC"
                                                    rules="required"
                                                >
                                                    <b-form-input
                                                        id="cedula_ruc"
                                                        v-model="datosFacturacion.documento_identidad"
                                                        placeholder="Ingrese cédula o RUC..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="cedula_ruc"
                                                        data-vv-as="cédula/RUC"
                                                        maxlength="13"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="mb-2">
                                                <label>Correo Electrónico <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Correo Electrónico"
                                                    rules="required"
                                                >
                                                    <b-form-input
                                                        id="correo"
                                                        v-model="datosFacturacion.email"
                                                        placeholder="Ingrese correo..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="correo"
                                                        data-vv-as="correo electrónico"
                                                        maxlength="100"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="">
                                                <label>País <span class="text-danger">*</span></label>
                                                <v-select
                                                    v-model="datosFacturacion.pais"
                                                    :options="paisOptions"
                                                    :reduce="(option) => option.value"
                                                    label="text"
                                                    class="checkout-select"
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="mb-2">
                                                <label>Ciudad <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Ciudad"
                                                    rules="required"
                                                >
                                                    <b-form-input
                                                        id="ciudad"
                                                        v-model="datosFacturacion.ciudad"
                                                        placeholder="Ingrese ciudad..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="ciudad"
                                                        maxlength="100"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="mb-2">
                                                <label>Dirección <span class="text-danger">*</span></label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Dirección"
                                                    rules="required"
                                                >
                                                    <b-form-input
                                                        id="direccion"
                                                        v-model="datosFacturacion.direccion"
                                                        placeholder="Ingrese direccion..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="direccion"
                                                        maxlength="100"
                                                        data-vv-as="Dirección"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                        <b-col lg="6" md="12">
                                            <b-form-group class="mb-2">
                                                <label>Teléfono </label>
                                                <validation-provider
                                                    #default="{ errors }"
                                                    name="Teléfono"
                                                    rules=""
                                                >
                                                    <b-form-input
                                                        id="telefono"
                                                        v-model="datosFacturacion.telefono"
                                                        placeholder="Ingrese telefono..."
                                                        :state="errors.length > 0 ? false:null"
                                                        name="telefono"
                                                        maxlength="100"
                                                        data-vv-as="Teléfono"
                                                    />
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </validation-provider>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </div>
                                <div class="checkout-form">
                                    <h3 class="titulo-checkout">Cuenta</h3>
                                    <div>
                                        <p>
                                            A continuación, indique el correo que desea utilizar para su cuenta
                                        </p>
                                        <b-form-group class="mt-2 mb-2">
                                            <label>Correo Electrónico <span class="text-danger">*</span></label>
                                            <validation-provider
                                                #default="{ errors }"
                                                name="Cuenta"
                                                rules="required"
                                            >
                                                <b-form-input
                                                    id="cuenta_correo"
                                                    v-model="cuenta.usuario"
                                                    placeholder="Ingrese correo electrónico..."
                                                    :state="errors.length > 0 ? false:null"
                                                    name="cuenta_correo"
                                                    data-vv-as="correo electrónico"
                                                    maxlength="100"
                                                />
                                                <small class="text-danger">{{ errors[0] }}</small>
                                            </validation-provider>
                                        </b-form-group>
                                    </div>
                                </div>
                            </b-col>
                            <b-col lg="6">
                                <div class="checkout-form con-borde">
                                    <h3 class="titulo-checkout">Orden de Compra</h3>
                                    <b-col cols="12" class="mt-3">
                                            <!-- <hr> -->
                                            <!-- <p class="font-semibold mb-2 list-unstyled"><b>Detalle de Orden</b></p> -->
                                            <div class="d-flex justify-content-between mb-1">
                                                <b><span style="font-size: 1.3rem;">Detalles</span></b>
                                                <b><span style="font-size: 1.3rem;">Total</span></b>
                                            </div>
                                            <div class="d-flex justify-content-between mb-1" v-for="producto in carrito" :key="producto.token">
                                                <span class="ml-2">{{ producto.nombre }}</span>
                                                <span>${{ producto.precio }}</span>
                                            </div>
                                            <hr>
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="">Subtotal</span>
                                                <span>${{ subtotalCarrito }}</span>
                                            </div>
                                            <hr>
    <!--                                        <div class="d-flex justify-content-between mb-1">-->
    <!--                                            <span class="">Descuento</span>-->
    <!--                                            <span class="text-success">-</span>-->
    <!--                                        </div>-->
                                            <div class="d-flex justify-content-between mb-1">
                                                <span class="">Impuestos (IVA 15%)</span>
                                                <span>${{ calcularImpuestos }}</span>
                                            </div>
                                            <hr>
                                            <div class="d-flex justify-content-between font-semibold mb-1">
                                                <b><span>Total</span></b>
                                                <b><span class="text-primary">${{ calcularTotal }}</span></b>
                                            </div>
                                    </b-col>
                                </div>
                                <div class="checkout-form con-borde">
                                    <h3 class="titulo-checkout">Método de Pago</h3>
                                    <div class="mt-2">
                                        <b-form-select
                                            v-model="metodoPago"
                                            :options="optionsPago"
                                        />
                                        <div class="mt-2" v-if="metodoPago === 'TAR'">
                                            <p>
                                                Realice el pago online mediante tarjeta de crédito
                                            </p>
                                            <div class="text-center mt-2">
                                                <a href="#">
                                                   <img src="@/assets/img/checkout/mastercard-card.png" alt="mastercard card" height="36">
                                                   <img src="@/assets/img/checkout/visa-card.jpg" alt="visa card" height="36" width="50">
                                                   <img src="@/assets/img/checkout/american-card.png" alt="american express card" height="36">
                                                   <img src="@/assets/img/checkout/diners-card.png" alt="diners club card" height="36" width="100">
                                                </a>
                                            </div>
                                        </div>

                                        <div class="mt-2" v-else-if="metodoPago === 'BAN'">
<!--                                            <p>A continuación se muestra información de la cuenta a la que debe realizar la transferencia o depósito:</p>-->
                                            <div class="text-center mt-1">
                                                <b>Banco del Pacífico Cuenta Corriente #8337934</b><br>
                                                <b>Compañía: </b>LEGALBYTEZ S.A.S.<br>
                                                <b>R.U.C.: </b>0993386813001<br>
                                                <b>Correo: </b>contabilidad@legalbytez.com<br>
                                            </div>

                                            <div class="text-center">
                                                <a href="#">
                                                    <img src="@/assets/img/checkout/banco-pacifico.png" alt="banco pacifico" height="100" width="100">
                                                    <img src="@/assets/img/checkout/cash-payment.png" alt="cash" height="40" width="70">
                                                </a>
                                            </div>

                                            <br>
                                            <p>Una vez realizado el pago, suba el comprobante aquí. Solo se permiten archivos PDF e imágenes JPG y PNG.</p>
                                            <div class="mb-40 text-center">
                                                <label for="upload_file" class="custom-file-upload">
                                                    <feather-icon icon="UploadIcon" size="18"/> Subir archivo
                                                </label>
                                                <input id="upload_file" type="file" accept=".jpg,.png,.pdf" @change="onUploadFile" multiple>
                                                <!-- <input id="upload_file" type="file" accept=".jpg,.png,.pdf" @change="onUploadFile" multiple> -->
                                                <div class="mt-2">
                                                    <div v-if="filesEvidencias.length > 0" class="files">
                                                        <div class="file-item" v-for="(file, index) in filesEvidencias" :key="index">
                                                            <span>{{ file.name }}</span>
                                                            <span class="delete-file" @click="handleClickDeleteFile(index)">Eliminar</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div style="display:flex;" class="mt-4">
                                            <b-form-checkbox v-model="datosFacturacion.terminos_condiciones"></b-form-checkbox><span>Acepto los <a href="https://www.legalbytez.com/terminos-condiciones/" target="_blank" style="font-weight:600;">Términos y condiciones</a></span>
                                        </div>

                                        <div style="width: fit-content; margin: auto; padding: 1%; display: flex;" class="mt-2">
                                            <b-button @click="initializePayment()" :disabled="!datosFacturacion.terminos_condiciones" variant="primary">Pagar</b-button>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BFormCheckbox, BTableSimple, BImg, BFormSelect  }  from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import es from 'vee-validate/dist/locale/es'
import paises from '@/assets/utils/paises.js';
import vSelect from 'vue-select'

import axios from "@/axios";

localize({
  es,
})

localize('es')

import { obtenerTipoPersonaFacturacion } from "@/assets/utils/actions.js";

import { required } from '@validations'

export default {
    components: {
        BOverlay,
        BRow,
        BCol,
        BFormGroup, 
        BFormInput, 
        BForm, 
        BButton,
        ValidationProvider,
        ValidationObserver,
        BFormCheckbox,
        BTableSimple,
        vSelect,
        BImg,
        BFormSelect
    },

    data() {
        return {
            mostrarLoader: false,
            paisOptions: paises.paises,
            datosFacturacion: {
                razon_social: '',
                documento_identidad: '',
                tipo_persona: '',
                email: '',
                pais: 'Ecuador',
                direccion: '',
                ciudad: '',
                telefono: '',
                terminos_condiciones: '',
            },
            cuenta: {
                usuario: '',
            },
            metodoPago: 'TAR',
            optionsPago: [
                { value: 'TAR', text: 'Tarjeta de Crédito' },
                { value: 'BAN', text: 'Transferencia o Depósito bancario' },
            ],
            porcentajeImpuestos: 15,
            prefix_dev_reference_producto: '',
            paymentez_init_reference: '',
            env_mode: '',
            required,
            filesEvidencias: [],
        }
    },

    methods:{
        initializePayment(){
            this.$refs.checkoutValidation.validate().then(success => {
                if(success){
                    this.$swal({
                        title: 'Finalizar Compra',
                        text: '¿Está seguro de finalizar la compra?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#192A4A',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                    }).then(result => {
                        if (result.value) {
                            this.mostrarLoader = true
                            this.obtenerTipoPersona()

                            if(this.metodoPago === 'TAR'){
                                this.makeCheckoutPaymentez()
                            }
                            else if(this.metodoPago === 'BAN'){
                                if(this.filesEvidencias.length <= 0) {
                                    this.$swal({
                                        title: 'Error',
                                        text: 'No ha subido ningún comprobante',
                                        icon: 'error',
                                        confirmButtonColor: '#192A4A',
                                        confirmButtonText: 'Aceptar',
                                    })
                                    this.mostrarLoader = false
                                }
                                else{
                                    this.procesarPagoCarrito()
                                }
                            }
                        }
                    })
                }
                else {
                    this.$swal({
                        title: 'Error',
                        text: 'Verifique la información ingresada en el formulario',
                        icon: 'error',
                        confirmButtonColor: '#192A4A',
                    })
                }
            })
        },
        obtenerTipoPersona(){
          const cedulaRuc = this.datosFacturacion.documento_identidad
          this.datosFacturacion.tipo_persona = obtenerTipoPersonaFacturacion(cedulaRuc)
        },
        obtenerConfigPaymentez(){
            this.mostrarLoader = true
            axios.post('api/orden/get-config-paymentez/').then(response => {
                // console.log("obtener config paymentez")
                // console.log(response.data.data)
                if (response.data.status == 'success'){
                    this.prefix_dev_reference_producto = response.data.data.prefix_dev_reference_producto
                    this.env_mode = response.data.data.env_mode
                }else{
                    this.$swal({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonColor: '#192A4A',
                        confirmButtonText: 'Aceptar',
                    })
                }
                this.mostrarLoader = false
            })
        },
        inicializarPaymentezPaycard(){
            let thisComponent = this
            // eslint-disable-next-line
            this.paymentCheckout = new PaymentCheckout.modal({
                // client_app_code: thisComponent.credenciales_paymentez.client_app_code, // Client Credentials
                // client_app_key: thisComponent.credenciales_paymentez.client_app_key, // Client Credentials
                locale: 'es', // User's preferred language (es, en, pt). English will be used by default.
                env_mode: 'prod', // `prod`, `stg`, `local` to change environment. Default is `stg`


                onResponse: async function (response) { // The callback to invoke when the Checkout process is completed
                    // console.log("++++++++++++++++++++++++++++++++++++++++++")
                    // console.log(response)
                    // console.log("++++++++++++++++++++++++++++++++++++++++++")
                    if(response.transaction.status_detail == 3){
                        thisComponent.mostrarLoader = true
                        await thisComponent.procesarPagoCarrito(response)
                    }
                    else{
                        thisComponent.$swal({
                            title: 'Error',
                            text: 'Ha ocurrido un error con su pago, vuelva a intentarlo en un momento. ERROR: ' + String(response.transaction.current_status) + '. ' + String(response.transaction.message),
                            icon: 'error',
                            confirmButtonColor: '#192A4A',
                        })
                    }
                }
            })
        },
        makeCheckoutPaymentez(){
          this.mostrarLoader =true
          let order = {
              amount: parseFloat(this.calcularTotal),
              description: 'Pago por compra online',
              vat: parseFloat(this.calcularImpuestos),
              taxable_amount: parseFloat(this.subtotalCarrito),
              tax_percentage: parseFloat(String(this.porcentajeImpuestos)),
              dev_reference: this.prefix_dev_reference_producto + String(Date.now()) + '_' + this.datosFacturacion.email,
          }
          let user = {
              id: this.datosFacturacion.email,
              email: this.datosFacturacion.email
          }

          axios.post('api/orden/generar-checkout-reference/',{
              order: order,
              user: user,
          }).then(
              response => {
                this.mostrarLoader = false
                  if(response.data.status == 'success'){
                    // console.log("reference es---->")
                    // console.log(response.data.data)
                      this.paymentCheckout.open({
                          reference: response.data.data // reference received for Payment Gateway
                      });
                  }
                  else{
                      this.$swal({
                          title: 'Error!',
                          text: response.data.message,
                          icon: 'error',
                          confirmButtonColor: '#192A4A',
                          confirmButtonText: 'Aceptar',
                      })
                  }
              })
        },
        procesarPagoCarrito(datosPago=null){
            let carrito = JSON.parse(localStorage.getItem('carritoLegalbytez'))

            let datosOrden = {
                total: this.calcularTotal,
                subtotal: this.subtotalCarrito,
                impuestos: this.calcularImpuestos,
                detalle_orden: carrito
            }
            axios.post('api/orden/procesar-pago-carrito/',{
                datosPago: datosPago,
                datosFacturacion: this.datosFacturacion,
                datosOrden: datosOrden,
                metodoPago: this.metodoPago,
                filesEvidencias: this.filesEvidencias,
                cuenta: this.cuenta,
            }).then(
                response => {
                    if(response.data.status == 'success'){
                        this.$swal({
                            title: 'Compra finalizada',
                            text: response.data.message,
                            icon: 'success',
                            showCancelButton: true,
                            confirmButtonColor: '#192A4A',
                            confirmButtonText: 'Aceptar',
                            cancelButtonText: 'Cancelar',
                        }).then(result => {
                            localStorage.removeItem('carritoLegalbytez')
                            window.location.href = "https://www.legalbytez.com/"
                        })
                    }
                    else{
                        this.$swal({
                            title: 'Error',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonColor: '#192A4A',
                            confirmButtonText: 'Aceptar',
                        })
                    }
                    this.mostrarLoader = false
                }
            )
        },
        onUploadFile(event){
            const selectedFiles = event.target.files;
            for (const file of selectedFiles){
                if (Math.round((file.size / this.limite_file)) > this.limite_file) {
                    this.$swal({
                        title: 'Error!',
                        text: 'Tamaño de archivo no permitido. El peso máximo es de 1MB.',
                        icon: 'error',
                        confirmButtonColor: '#0F80C1',
                        confirmButtonText: 'Aceptar',
                    })
                    return false
                }
                else if(this.checkFileExtension(file.name)){
                    this.$swal({
                        title: 'Error!',
                        text: 'Formato de archivo no permitido. Solo se acepta JPG y PNG.',
                        icon: 'error',
                        confirmButtonColor: '#0F80C1',
                        confirmButtonText: 'Aceptar',
                    })
                    return false
                }
                else{
                    this.createBase64File(file);
                }
            }
            document.getElementById("upload_file").value = '';
        },
        checkFileExtension(filename){
            filename = filename.toLowerCase();
            const ext = filename.split('.').pop();
            if(ext!='png' && ext!='jpg' && ext!='jpeg' && ext!='pdf'){
                return true
            }
            return false
        },
        createBase64File(fileObject){
            const reader = new FileReader();
            reader.onload = (e) => {
                let newFile = {'name': fileObject.name, 'data': e.target.result}
                this.filesEvidencias.push(newFile)
            };
            reader.readAsDataURL(fileObject);
        },
        handleClickDeleteFile(index){
            this.filesEvidencias.splice(index, 1);
        },
    },
    computed: {
        subtotalCarrito() {
            let carrito = JSON.parse(localStorage.getItem('carritoLegalbytez'))

            let subtotal = 0.00
            carrito.forEach((producto) => {
               subtotal += producto.precio
            })

            return parseFloat(subtotal).toFixed(2)
        },
        calcularImpuestos() {
            let subtotal = this.subtotalCarrito
            let impuestos = subtotal * this.porcentajeImpuestos/100

            return impuestos.toFixed(2)
        },
        calcularTotal() {
            let subtotal = String(this.subtotalCarrito)
            let impuestos = String(this.calcularImpuestos)

            let total = parseFloat(subtotal) + parseFloat(impuestos)
            return total.toFixed(2)
        },
        carrito() {
            return JSON.parse(localStorage.getItem('carritoLegalbytez'))
        },
    },
    mounted() {
        if(localStorage.getItem('carritoLegalbytez') === null || localStorage.getItem('carritoLegalbytez')==='[]'){
            window.location.href = "https://www.legalbytez.com/404/"
        }
        this.obtenerConfigPaymentez()
        this.inicializarPaymentezPaycard()
    },
}

</script>

<style>
#logoContainer {
    width: 100%;
    height: 60px;
}

.logo {
    height: 43px;
    margin-top: 8px;
}

#checkout_container {
    min-height: 95vh;
    position: relative;
    top: 60px;
}

.pricing-free-trial{
    position: relative;
}

.checkout-form {
    padding: 30px 40px 45px;
    margin-bottom: 7%;
}

.checkout-form.con-borde {
    border: 3px solid #eaedff;
}

.titulo-checkout {
    font-size: 26px;
    border-bottom: 2px solid #eaedff;
    font-weight: 700;
}

.checkout-select {
    background-color: #fff;
}

.custom-file-upload {
    display: inline-block;
    cursor: pointer;
    color: #ffffff;
    background-color: #007bff;
    padding: 10px 20px;
    border-radius: 5px;
    font-size: 16px;
    transition: background-color 0.3s;
}
.custom-file-upload:hover {
    background-color: #0056b3;
}
.custom-file-upload i {
    margin-right: 8px;
}
#upload_file {
    display: none;
}

.files {
    width: 100%;
    max-width: 75%;
    margin: 0 auto;
    padding: 10px;
    border-radius: 8px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
    font-size: 12px;
    line-height: 1.5;
}

.file-item {
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    /*background: rgb(255 167 18 / 20%);*/
    padding: 7px;
    padding-left: 15px;
    //margin-top: 20px;
}
&:first-child {
    margin-top: 0;
}

.delete-file {
    background: red;
    color: #fff;
    padding: 5px 10px;
    border-radius: 8px;
    cursor: pointer;
}

</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
